import {Component, ViewChild, ElementRef, OnInit, OnDestroy, DoCheck, Input, EventEmitter, Output} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {PlanModel} from '../../common/service/plan-model.model';
import {selectedPurpose, ParentPlanType, FormerTenureSubjectOfPlans} from '../../lodge-field-record/lodge-field-record.model';
import {selectedLodgementType, FormerTenureViewModel} from '../../lodge-field-record/lodge-field-record.model';
import {NlrFieldRecordFomerTenureModalDataService} from '../../common/component/modal/field-record-former-tenure-modal/field-record-former-tenure-modalData.service';
import {FieldRecordFormerTenureModalComponent} from '../../common/component/modal/field-record-former-tenure-modal/field-record-former-tenure-modal.component';

@Component({
    selector: 'nlr-field-record-former-tenure',
    imports: [FormsModule, FieldRecordFormerTenureModalComponent],
    templateUrl: './field-record-former-tenure.component.html',
    styleUrl: './field-record-former-tenure.component.scss'
})
export class FieldRecordFormerTenureComponent implements OnInit, DoCheck, OnDestroy {
    planModel: PlanModel = undefined;
    previousPurpose = undefined;
    formerTenureViewModels: FormerTenureViewModel[];
    selectedPurposeSubjectOfPlans = [];
    formerTenures = [];
    isModalOpen = false;
    submitted = false;

    @Input()
    model: PlanModel;
    @Input()
    selectedPurpose: selectedPurpose;
    @Input()
    selectedLodgementType: selectedLodgementType;
    @Input()
    parentPlanTypes: ParentPlanType[];
    @Input()
    formerTenureSubjectOfPlans: FormerTenureSubjectOfPlans[];

    @Output()
    validationChanged = new EventEmitter<boolean>();

    @ViewChild('addFormerTenure', {static: false}) addFormerTenure!: ElementRef;

    constructor(private nlrFieldRecordFomerTenureModalDataService: NlrFieldRecordFomerTenureModalDataService) {}

    ngOnInit(): void {
        if (!this.model.formerTenures) {
            this.model.formerTenures = [];
        }

        if (this.model.formerTenures.length === 0) {
            this.model.formerTenures.push({});
            this.selectedPurpose.formerTenure === 'Mandatory' ? this.validationChanged.emit(false) : this.validationChanged.emit(true);
        }
    }

    ngDoCheck(): void {
        if (this.model.purpose !== this.previousPurpose) {
            this.previousPurpose = this.model.purpose;
            this.formerTenureViewModels = [];
            this.model.formerTenures = [];
            const selectedPurposeSubjectOfPlanCodes = (this.selectedPurpose.subjectOfPlans || '').split(',');
            this.selectedPurposeSubjectOfPlans = this.formerTenureSubjectOfPlans.filter(function (v) {
                return selectedPurposeSubjectOfPlanCodes.indexOf(v.id) !== -1;
            });
        }
    }

    ngOnDestroy(): void {
        // this.formerTenureViewModels.length = 0;
        // if (this.planModel.formerTenures) {
        //     this.planModel.formerTenures = undefined;
        // }
        // if (this.planModel.formerTenureSubjectOfPlan) {
        //     this.planModel.formerTenureSubjectOfPlan = undefined;
        // }
    }

    openFormerTenureModal() {
        const selectedPurposeParentPlanTypeCodes = (this.selectedPurpose.parentPlanType || '').split(',');
        const parentPlanType = this.parentPlanTypes.filter(function (v) {
            return selectedPurposeParentPlanTypeCodes.indexOf(v.code) !== -1;
        });

        this.nlrFieldRecordFomerTenureModalDataService.updateParentType(parentPlanType);
        this.nlrFieldRecordFomerTenureModalDataService.updateFormerTenures(this.model.formerTenures);

        this.isModalOpen = true;
    }

    dismissModal() {
        this.isModalOpen = false;
        this.addFormerTenure.nativeElement.focus();
    }

    formerTenureSubjectOfPlanChanged(option: string) {
        this.model.formerTenureSubjectOfPlan = option;
    }

    hasMinFormerTenures() {
        return (
            !this.selectedLodgementType.applyFormerTenureValidation ||
            this.selectedPurpose.formerTenure !== 'Mandatory' ||
            this.model.formerTenures.length > 0
        );
    }

    saveModalData() {
        this.initializeFormerTenureModels();
        this.nlrFieldRecordFomerTenureModalDataService.getFormerTenures().subscribe(data => {
            data.forEach((v, i) => {
                this.formerTenureViewModels[i] = v;
                this.model.formerTenures[i] = v;
            });
            this.validationChanged.emit(this.model.formerTenures.length > 0);
        });

        this.isModalOpen = false;
    }

    getParentPlanTypeName(parentPlanType: string) {
        return this.parentPlanTypes.filter(type => type.id === parentPlanType)[0].name;
    }

    initializeFormerTenureModels() {
        this.formerTenureViewModels = [];
        this.model.formerTenures = [];
    }
}
